<template>
  <div
    class="w-full h-1 dark:bg-nucleus-darkBlue shadow-md relative -top-1"
    :class="checkAccessPage(currentRouteName) ? 'bg-black' : 'bg-white'"
  ></div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { isAccessPage } from "@/utils/isAccessPage";

@Options({
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    checkAccessPage(route: string) {
      return isAccessPage(route);
    },
  },
})
export default class HeaderShadow extends Vue {}
</script>
